import type { CityConfig } from "../city-template/types";

export const sheridanWyConfig: CityConfig = {
  city: "Sheridan",
  state: "Wyoming",
  stateAbbr: "WY",
  slug: "sheridan-wy",
  route: "/cities/sheridan-wy",
  title: "Emergency Passport Sheridan, WY — Expedited Same-Day Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Sheridan, WY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Sheridan, Buffalo, Sheridan County, and northern Wyoming travelers. No Denver or Billings trip needed.",
  h1: "Emergency & Expedited Passport Services in Sheridan, WY",
  heroSubtitle: "Sheridan College student heading to study abroad? Bighorn Mountain ranch family planning an international trip? Sheridan's historic Main Street business owner traveling to an overseas trade show? We help Sheridan residents — from Bighorn National Forest outdoor guides to Sheridan County ranchers to downtown entrepreneurs — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20view%20of%20Sheridan%20Wyoming%20with%20the%20majestic%20Bighorn%20Mountains%20rising%20dramatically%20in%20the%20background%2C%20historic%20downtown%20Main%20Street%20with%20beautifully%20preserved%20western%20architecture%20and%20the%20iconic%20Mint%20Bar%20neon%20sign%2C%20wide%20tree-lined%20streets%20with%20classic%20street%20lamps%2C%20the%20lush%20Tongue%20River%20valley%20at%20golden%20hour%20with%20warm%20light%20on%20the%20mountain%20peaks%2C%20editorial%20travel%20photography%20with%20rich%20natural%20colors&width=1800&height=700&seq=sheridan-hero-2026&orientation=landscape",
  heroImageAlt: "Sheridan Wyoming with Bighorn Mountains backdrop and historic Main Street at golden hour",
  geoPosition: "44.7972;-106.9562",
  geoPlacename: "Sheridan, Wyoming",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 510, Aurora, CO 80014",
    distance: "Nearest regional passport agency — located approximately 450 miles from Sheridan via I-90 and I-25; a 7+ hour drive one way",
  },
  nearbyCitiesZips: [
    { name: "Sheridan", zips: "82801" },
    { name: "Buffalo", zips: "82834" },
    { name: "Ranchester", zips: "82839" },
    { name: "Dayton", zips: "82836" },
    { name: "Clearmont", zips: "82835" },
    { name: "Big Horn", zips: "82833" },
    { name: "Story", zips: "82842" },
    { name: "Banner", zips: "82832" },
  ],
  benefits: [
    { icon: "ri-landscape-line", title: "Bighorn Mountain & Cross-Border Recreation Expertise", desc: "Sheridan is the gateway to the Bighorn National Forest and sits on the route between Yellowstone and the Black Hills. Many Sheridan residents travel between U.S. and Canadian Rockies, making passport readiness essential for outdoor adventurers and guides." },
    { icon: "ri-flight-takeoff-line", title: "SHR — Sheridan County Airport", desc: "SHR connects to Denver International Airport via United Express. DIA is a major international gateway. We coordinate passport timelines around SHR connections to Denver and beyond." },
    { icon: "ri-building-2-line", title: "Between Denver (450 mi) and Billings (130 mi)", desc: "Denver is the nearest passport agency at 450 miles — a 7+ hour drive. Billings, MT is closer at 130 miles but has no passport agency. Our courier service bridges both gaps for northern Wyoming travelers." },
    { icon: "ri-home-2-line", title: "Historic Ranching Community with Global Connections", desc: "Sheridan County's historic ranches and polo community have international ties spanning Argentina, the UK, and Australia. We serve this unique community with expertise in the travel patterns of northern Wyoming's internationally connected families." },
  ],
  internalLinks: [
    { name: "Expedited passport in Gillette, WY", route: "/cities/gillette" },
    { name: "Fast passport services in Casper, WY", route: "/cities/casper" },
    { name: "Quick passport in Billings, MT", route: "/cities/billings" },
    { name: "Urgent passport services in Cody, WY", route: "/cities/cody" },
    { name: "Wyoming passport services overview", route: "/cities/wyoming-state" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 510, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Sheridan via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 7+ hours to Colorado. Sheridan residents can ship from any UPS Store, FedEx Office, or post office location across Sheridan County.",
  fpcOfficeDistance: "Serving Sheridan, Buffalo, Ranchester, Dayton, Clearmont, Big Horn, Story, Banner, and all Sheridan County and northern Wyoming communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Sheridan and Sheridan County. From the historic Main Street district to the Bighorn Mountain foothills, from the Tongue River valley ranches to the Powder River breaks — we serve all of northern Wyoming. Our courier service eliminates the need to drive to Denver for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Sheridan and all Sheridan County communities including Buffalo, Ranchester, Dayton, and Clearmont. We also serve Bighorn National Forest guides, Sheridan County ranchers, and Sheridan College students planning international travel.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Sheridan as simple as possible — with the reliability Bighorn Mountain guides, Sheridan County ranch families, and Sheridan College students need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Sheridan travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Sheridan travelers encounter unique passport issues — from Bighorn Mountain seasonal employment documentation to Sheridan County ranch address verification to Sheridan College study abroad deadlines. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Northern Wyoming travelers — from Bighorn Mountain outdoor guides to Sheridan County ranching families to Sheridan College students — trust us when their international departure is days away and Denver is simply not an option.",
  faqIntro: "Have questions about expedited passports in Sheridan, WY? Here are the most common ones we hear from Sheridan County travelers.",
  statePageRoute: "/cities/wyoming-state",
  statePageName: "Wyoming",
  servicesIntro: "Whether you need a renewal before a Canadian Rockies adventure, an emergency passport for a last-minute SHR connection, or a first-time passport for a Sheridan County family vacation abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dot.state.wy.us/driverservices",
  dmvLabel: "Wyoming Department of Transportation — Driver Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 450 miles from Sheridan", "7+ hour drive — completely impractical for Sheridan County residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Denver trip needed — we handle everything remotely", "Ideal for Bighorn outdoor adventures and ranch family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Sheridan or Buffalo", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "SHR connection for Bighorn outdoor guide heading to Canada in 2 days? Last-minute ranch exchange trip? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Sheridan travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Sheridan residents renew fast — no agency visit required. Perfect for Sheridan County ranch families and Bighorn outdoor enthusiasts.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Sheridan County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed — so your international adventure or family trip stays on track.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions for your Sheridan County family trip abroad.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Sheridan County ranch owners with international agricultural partnerships and Main Street business owners with overseas clients.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Sheridan County travelers through the process.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Sheridan residents crossing into Canada from Alberta and Saskatchewan.",
      bullets: ["Wallet-size convenience", "Land and sea crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Sheridan WY", description: "Urgent passport processing for Sheridan Wyoming travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Sheridan WY", description: "Fast passport renewal for Sheridan Wyoming residents with a previously-issued passport." },
    { name: "First-Time Passport Sheridan WY", description: "New passport application services for Sheridan Wyoming residents applying for their first passport." },
    { name: "Child Passport Sheridan WY", description: "Minor passport services for Sheridan Wyoming families with children under 16." },
    { name: "Name Change Passport Sheridan WY", description: "Passport name correction after marriage, divorce, or legal name changes for Sheridan residents." },
    { name: "Second Passport Sheridan WY", description: "Second passport services for Sheridan frequent travelers and ranch business professionals." },
  ],
  testimonials: [
    {
      name: "Katherine M.",
      location: "Sheridan",
      rating: 5,
      text: "Our ranch hosts international guests and we travel to Argentina for polo every year. When my passport renewal was delayed, Fast Passport Center got it done in 5 days. Driving to Denver — 450 miles — was never an option. This service is a lifeline for northern Wyoming.",
      service: "Passport Renewal",
    },
    {
      name: "Jake T.",
      location: "Sheridan",
      rating: 5,
      text: "Bighorn Mountain guide heading to Banff for the summer season. Realized my passport was expiring 2 weeks before I needed to cross the border. Fast Passport Center had my renewal back in 4 days. Made my season. Absolutely clutch for outdoor pros in Sheridan.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "The Evans Family",
      location: "Buffalo",
      rating: 5,
      text: "Family trip to New Zealand — two kids needed first passports. Fast Passport Center walked us through the process, caught a photo issue from the Buffalo post office, and got all four passports back with time to spare. Saved us from a Denver nightmare.",
      service: "Child Passports — Family",
    },
    {
      name: "Maria G.",
      location: "Sheridan",
      rating: 5,
      text: "Sheridan College exchange program to Spain. My passport was expired and I had 3 weeks until orientation. Fast Passport Center expedited everything and I had my passport in 5 days. Without them I would have deferred an entire semester.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "sheridan-1",
      name: "Sheridan Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 E Loucks St",
      city: "Sheridan",
      state: "WY",
      zip: "82801",
      phone: "(307) 672-0755",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Sheridan",
      website: "https://tools.usps.com/find-location.htm?location=1373617",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Sheridan County. Appointment availability can fill quickly during summer tourist season — schedule at least a week in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "sheridan-2",
      name: "Sheridan County Clerk of District Court",
      type: "County Clerk Passport Acceptance",
      address: "224 S Main St, Suite B-11",
      city: "Sheridan",
      state: "WY",
      zip: "82801",
      phone: "(307) 674-2960",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Downtown Sheridan — Sheridan County Courthouse",
      website: "https://www.sheridancountywy.gov/",
      websiteLabel: "Sheridan County Website",
      notes: "Alternative to post office acceptance facilities. Appointment recommended. Does not offer photo services — bring your own passport photo.",
      icon: "ri-government-line",
    },
    {
      id: "sheridan-3",
      name: "Buffalo Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "193 S Main St",
      city: "Buffalo",
      state: "WY",
      zip: "82834",
      phone: "(307) 684-7571",
      hours: "Mon–Fri 8:30 AM – 4:30 PM (appointment required)",
      distance: "Buffalo — about 35 miles south of Sheridan via I-90",
      website: "https://tools.usps.com/find-location.htm?location=1364733",
      websiteLabel: "USPS Location",
      notes: "Serves Johnson County and southern Sheridan County. Good alternative when Sheridan appointments are fully booked.",
      icon: "ri-mail-line",
    },
    {
      id: "sheridan-4",
      name: "Sheridan College — Campus Services",
      type: "Campus Passport Services",
      address: "1 Whitney Way",
      city: "Sheridan",
      state: "WY",
      zip: "82801",
      phone: "(307) 675-0505",
      hours: "Mon–Fri 8:00 AM – 5:00 PM (limited passport services — call for availability)",
      distance: "Sheridan College Campus",
      website: "https://www.sheridan.edu/",
      websiteLabel: "Sheridan College Website",
      notes: "Limited passport services primarily for students and staff. Call ahead to confirm current passport acceptance availability.",
      icon: "ri-government-line",
    },
    {
      id: "sheridan-5",
      name: "Gillette Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "311 S Gillette Ave",
      city: "Gillette",
      state: "WY",
      zip: "82716",
      phone: "(307) 682-4843",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Gillette — about 100 miles southeast of Sheridan via I-90",
      website: "https://tools.usps.com/find-location.htm?location=1366040",
      websiteLabel: "USPS Location",
      notes: "Alternative facility in northeastern Wyoming. About 1.5 hours from Sheridan — useful when traveling through the Powder River Basin.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 450 miles and 7+ hour drive from Sheridan one way", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Aurora, CO; 14+ hour round trip from Sheridan", fpc: "Most Sheridan travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — must prove travel date and emergency", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay, especially problematic from rural northern Wyoming", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Sheridan Residents", agency: "450-mile drive to Denver — completely impractical for Sheridan County residents", fpc: "Entirely remote — forms online, ship from Sheridan, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in 14+ hours of driving, time off work, and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Sheridan County Context", agency: "No Sheridan-specific guidance — no Bighorn Mountains, Sheridan College, or ranch community expertise", fpc: "Full Sheridan County knowledge — outdoor recreation, polo and ranch travel, Sheridan College patterns" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Bighorn Mountain Seasonal Employment Passport Gaps",
      description: "Bighorn National Forest guides and seasonal workers often transition between U.S. and Canadian Rockies positions. An expired passport can mean missing an entire season's opportunity. Check passport validity before the summer season starts.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for SHR Connection Timing",
      description: "SHR connects to Denver International Airport. Your passport is checked at Sheridan check-in, not at DIA. An expired or near-expired passport will prevent boarding at SHR even if your international flight from Denver is days away.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Sheridan County Rural Address Documentation",
      description: "Ranch addresses and rural route numbers in Sheridan County (especially around Banner, Story, and Big Horn) can differ from residential addresses on supporting documents. We review all documentation to catch address mismatches.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards from Small-Town Retailers",
      description: "Photos from Sheridan pharmacies and smaller retail photo services may not meet strict State Department standards. We catch lighting, background, and sizing issues in review before they cause a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming Billings Is a Viable Alternative to Denver",
      description: "Billings, MT is 130 miles north — much closer than Denver's 450 miles. But Billings does not have a regional passport agency. Denver is still the only agency option. Our courier service eliminates the need for either city.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether a Canadian Rockies adventure, ranch family vacation, or Sheridan College study abroad program." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your situation — outdoor guide, ranch family, or Sheridan College student." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Sheridan clients ship from the UPS Store on Coffeen Avenue or the Sheridan Post Office on Loucks Street." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our processing center. We submit through reserved agency slots — so Sheridan County travelers never need to drive to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is completed within your selected timeframe and shipped directly to your Sheridan, Buffalo, or Sheridan County address. No agency visit. No Denver. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Sheridan, Wyoming?", a: "We offer Sheridan-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. The nearest regional passport agency is in Denver (450 miles away) — our remote courier service is the most practical fast option in northern Wyoming." },
    { q: "Do I need to visit a Sheridan office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Sheridan Post Office or Sheridan County Clerk), then ship documents overnight. We handle the State Department submission and return your passport to your Sheridan County address." },
    { q: "Where can I get passport acceptance near Sheridan?", a: "Sheridan has acceptance facilities at the Main Post Office on Loucks Street and the Sheridan County Clerk of District Court on Main Street. Nearby options include USPS locations in Buffalo and Gillette. We maintain an updated list of Sheridan County-area facilities." },
    { q: "I work as an outdoor guide in the Bighorns — can you handle short-notice passport needs?", a: "Yes. Bighorn Mountain guides and outdoor professionals are among our most frequent clients. When seasonal work transitions between U.S. and Canadian Rockies require a valid passport on short notice, we provide fast expedited processing. No Denver drive required." },
    { q: "Is Billings a viable alternative to Denver for passport agency appointments?", a: "Billings, MT is 130 miles from Sheridan (much closer than Denver at 450 miles), but Billings does not have a regional passport agency — only acceptance facilities like post offices. Denver is the nearest agency. For expedited processing, our courier service eliminates the need for either city." },
    { q: "What is the best price for expedited passport service in Sheridan?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "What documents do Sheridan applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent. We provide a Sheridan County-specific checklist." },
    { q: "Can I get a passport photo in Sheridan?", a: "Yes. The Sheridan Post Office offers limited on-site passport photos. CVS, Walgreens, and the UPS Store on Coffeen Avenue also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does SHR airport connect to international flights?", a: "Sheridan County Airport (SHR) connects to Denver International Airport (DIA) via United Express. DIA offers direct international flights worldwide. Your passport must be valid when you check in at SHR, as you are ticketed through to your international destination." },
    { q: "Can you help with passports for Sheridan College students?", a: "Yes. Sheridan College students heading abroad for study programs, exchanges, or transferring to international universities need timely passport processing. We help SC students navigate the process with clear checklists and fast expedited service." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Sheridan Residents",
    intro: "Sheridan's position between the Bighorn Mountains and the Powder River Basin, along the I-90 corridor in northern Wyoming, creates unique passport timing considerations. Here's what Sheridan County travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "SHR — Sheridan County Airport",
        subtitle: "The essential first leg for northern Wyoming international travel",
        description: "SHR connects to Denver International Airport via United Express turboprop service. From DIA, travelers access direct flights to Europe, Asia, and Latin America. The critical insight: your passport is checked at SHR check-in, not at DIA. If your passport isn't valid, you won't board in Sheridan.",
        tip: "Check your passport expiration when you book any itinerary departing from SHR. Winter weather in northern Wyoming can delay SHR connections — build in buffer time for international itineraries, especially November through March.",
      },
      {
        icon: "ri-landscape-line",
        title: "Bighorn Mountains & Cross-Border Outdoor Recreation",
        subtitle: "The natural corridor between the U.S. and Canadian Rockies",
        description: "The Bighorn National Forest and the broader Rocky Mountain corridor make Sheridan a hub for outdoor professionals and enthusiasts. Many guides, climbers, and backcountry experts work seasons in both the U.S. and Canada — Bighorns in summer, Canadian Rockies in winter, or vice versa. This cross-border seasonal rhythm demands passport readiness year-round.",
        tip: "Outdoor guides and seasonal workers should treat passport validity as professional equipment — check it before each season, not when a Canada opportunity surfaces. A passport card supplements a passport book for land crossings at Montana-Alberta and Saskatchewan border points.",
      },
      {
        icon: "ri-road-map-line",
        title: "I-90 Corridor & Northern Plains Connectivity",
        subtitle: "Sheridan's strategic position between multiple regions",
        description: "I-90 connects Sheridan to Billings (130 miles north), Gillette (100 miles southeast), and Buffalo (35 miles south). This corridor gives Sheridan travelers access to multiple airports: SHR, BIL (Billings Logan), and GCC (Gillette). For international travel, Denver and Billings-SLC connections are the primary gateway routes.",
        tip: "Billings Logan International Airport (BIL) offers more airline and flight options than SHR and is 130 miles away. For complex international itineraries, driving to Billings for a direct connection may save time over connecting through Denver from SHR.",
      },
      {
        icon: "ri-home-2-line",
        title: "Sheridan County Ranching & International Agricultural Connections",
        subtitle: "Historic ranches with global partnerships and travel patterns",
        description: "Sheridan County's historic ranches and polo community maintain international ties — from Argentine estancia exchanges to British equestrian events to Australian cattle station visits. These connections create regular international travel needs with seasonal patterns tied to the agricultural and equestrian calendars.",
        tip: "Ranch families with international agricultural partnerships should maintain passport validity year-round. Many ranch exchange programs and international livestock events have application deadlines 4-6 months ahead — begin passport processes well before those deadlines.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Sheridan & the Bighorn Mountain West",
      description: "Sheridan is one of the West's most beautifully preserved historic towns, with a Main Street that Buffalo Bill Cody himself once walked. Nestled against the Bighorn Mountains at the edge of the Tongue River Valley, Sheridan blends working ranch culture with an internationally connected arts and equestrian community. The King's Saddlery, the Brinton Museum, and the WYO Theater reflect a community that values both its Western heritage and its global outlook — making Sheridan one of Wyoming's most sophisticated small cities.",
    },
  },
  destinations: {
    title: "Where Sheridan Travelers Go — And Why Passports Get Urgent",
    intro: "Sheridan's identity as a historic ranching community at the foot of the Bighorn Mountains shapes its international travel patterns.",
    stats: [
      { stat: "35%", label: "of Sheridan expedited requests involve Canadian Rockies cross-border travel" },
      { stat: "2–4 Weeks", label: "average lead time from trip booking to departure for Sheridan County travelers" },
      { stat: "May–Sep", label: "peak season for Bighorn outdoor guides and summer family travel" },
      { stat: "450 Miles", label: "to nearest passport agency in Denver — our courier service bridges this" },
    ],
    destinations: [
      { name: "Canada", context: "Canadian Rockies guiding and recreation, Banff and Jasper National Parks, Calgary and Edmonton business and cultural connections, Saskatchewan ranch exchanges", urgency: "Seasonal outdoor work transitions and summer recreation", icon: "ri-map-pin-2-line" },
      { name: "Argentina", context: "Polo and equestrian exchanges, estancia visits, ranch management partnerships, Patagonia adventure travel", urgency: "Southern Hemisphere summer (November–February) polo season and ranch programs", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "UK equestrian events and heritage travel, Ireland ranch heritage connections, Sheridan College study abroad programs, Main Street business trade shows", urgency: "Fixed-date events and academic program deadlines", icon: "ri-map-pin-2-line" },
      { name: "Australia & New Zealand", context: "Cattle station exchanges, working holiday visas for Sheridan College graduates, adventure travel", urgency: "Post-graduation travel and seasonal ranch exchange windows", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Central America", context: "Winter ranch off-season getaways, Baja fishing trips, resort vacations, language immersion", urgency: "Fall and winter travel planning", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "Equestrian equipment manufacturing partnerships, Sheridan College international student travel, adventure tourism", urgency: "Business travel and academic calendar deadlines", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Wyoming Service Areas",
    crossLinksDesc: "We serve travelers across the Equality State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Gillette", route: "/cities/gillette" },
      { name: "Casper", route: "/cities/casper" },
      { name: "Billings, MT", route: "/cities/billings" },
    ],
  },
  photoLocations: [
    { name: "Sheridan Main Post Office", address: "101 E Loucks St, Sheridan, WY 82801", hours: "Mon–Fri 9 AM – 4 PM (limited photo service)" },
    { name: "The UPS Store — Sheridan", address: "1842 Sugarland Dr, Sheridan, WY 82801", hours: "Mon–Fri 8:30 AM – 6:30 PM, Sat 10 AM – 3 PM" },
    { name: "Walmart Supercenter — Sheridan", address: "1695 Coffeen Ave, Sheridan, WY 82801", hours: "Daily 6 AM – 11 PM" },
    { name: "Walgreens — Sheridan", address: "1766 Coffeen Ave, Sheridan, WY 82801", hours: "Daily 8 AM – 10 PM" },
    { name: "Smith's Food & Drug — Sheridan", address: "10 N Main St, Sheridan, WY 82801", hours: "Daily 6 AM – 11 PM" },
    { name: "Walgreens — Buffalo", address: "580 E Hart St, Buffalo, WY 82834", hours: "Daily 8 AM – 10 PM (35 miles south)" },
  ],
  dmvLocations: [
    {
      name: "Sheridan County Treasurer — Motor Vehicle Division",
      address: "224 S Main St, Suite B-2, Sheridan, WY 82801",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Johnson County Treasurer — Motor Vehicle",
      address: "76 N Main St, Buffalo, WY 82834",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration for Johnson County residents. About 35 miles south of Sheridan.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SHR",
      name: "Sheridan County Airport",
      distance: "About 2 miles southwest of downtown Sheridan (5 minutes via Coffeen Ave)",
      address: "908 W Brundage Ln, Sheridan, WY 82801",
      note: "Connects to Denver International Airport via United Express. Free parking. The primary departure point for Sheridan County international travelers.",
      flightUrl: "https://www.sheridanwy.gov/airport",
      flightLabel: "Sheridan Airport",
      featured: true,
    },
    {
      code: "BIL",
      name: "Billings Logan International Airport",
      distance: "About 130 miles north of Sheridan (2 hours via I-90)",
      address: "1901 Terminal Cir, Billings, MT 59105",
      note: "Larger regional airport with connections to Denver, Salt Lake City, Minneapolis, Seattle, and seasonal direct flights. Good alternative when SHR connections are limited.",
      flightUrl: "https://www.flybillings.com/",
      flightLabel: "Billings Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Wyoming birth certificates from the Wyoming Department of Health Vital Statistics Services. Online, mail, or in-person options available.",
      url: "https://health.wyo.gov/admin/vitalstatistics/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Wyoming Vital Statistics Services. Required for estate and legal matters in Sheridan County.",
      url: "https://health.wyo.gov/admin/vitalstatistics/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Sheridan County Clerk of District Court. Certified copies available for name changes and passport applications.",
      url: "https://www.sheridancountywy.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Sheridan County District Court. Required for name change passport corrections.",
      url: "https://www.sheridancountywy.gov/",
    },
  ],
};